<div class="screen-container d-flex fd-col ai-stretch">
  <div class="d-flex flex-wrap ai-stretch">
    <h4 class="margin">Subscription</h4>
  </div>

  <div class="d-flex flex-wrap ai-stretch">
    <div class="margin padding card flex-1 d-flex fd-col ai-stretch" *ngIf="selectedOrganisationRole?.organisationId">
      <lib-manage-subscription [navType]="'single'" [organisationId]="selectedOrganisationRole.organisationId"></lib-manage-subscription>
    </div>
  </div>

  <!-- TODO: MERGE INTO ONE COMPONENT -->
  <div class="top-margin d-flex flex-wrap ai-stretch" *ngIf="selectedOrganisationRole?.role === 'ADMIN'">
    <h4 class="margin">Billing Details</h4>
  </div>
  <div class="d-flex flex-wrap ai-stretch" *ngIf="selectedOrganisationRole?.role === 'ADMIN'">
    <div class="margin padding card flex-1 d-flex fd-col ai-stretch">
      <p>To manage your existing payment methods, click the button to go to the Stripe™ Customer Portal.</p>
      <br>
      <button button mat-raised-button color="primary" class="billing-portal-btn" (click)="goToCustomerPortal()">
        Manage Billing Details
      </button>
    </div>
  </div>
</div>